import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UserService from "../../services/UserService";

let initialState = {
    students: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllStudentsPageable = createAsyncThunk(
    'getAllStudentsPageable',
    async ({ page, limit, name = "", isGroupsNeeded }, {getState, rejectWithValue, dispatch}) => {
        try {
            return await UserService.getStudentsSearchable(page, limit, name, isGroupsNeeded);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const studentsListSlice = createSlice({
    name: 'studentsListSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllStudentsPageable.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllStudentsPageable.fulfilled, (state, action) => {
                state.isLoading = false;
                state.students = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllStudentsPageable.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.students = [];
                state.hasMore = false;
            })
    }
});

export const {} = studentsListSlice.actions;

export default studentsListSlice.reducer;